var exports = {
  "kL": "x43aef4ae--2cbbe7--container",
  "DD": "x43aef4ae--2cbbe7--title",
  "Sl": "x43aef4ae--2cbbe7--image",
  "SC": "x43aef4ae--2cbbe7--rectangle-container",
  "YC": "x43aef4ae--2cbbe7--rectangle",
  "kE": "x43aef4ae--2cbbe7--rectangle-text",
  "h_": "x43aef4ae--2cbbe7--description",
};

module.exports = exports;
